/* eslint-disable react/no-danger */
import { Tooltip } from 'antd';
import DOMPurify from 'dompurify';
import React from 'react';

interface TaskNameProps {
  taskName: string;
  dataCy?: string;
  className?: string;
  style?: React.CSSProperties;
}

interface PhaseNameProps {
  phaseName: string;
}

export const TaskName = ({
  taskName,
  dataCy,
  className,
  style,
}: TaskNameProps) => {
  return (
    <Tooltip
      destroyTooltipOnHide
      placement="topLeft"
      title={
        <div
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line import/namespace, @typescript-eslint/naming-convention
            __html: DOMPurify.sanitize(taskName),
          }}
        />
      }
    >
      <div
        data-cy={dataCy}
        style={style}
        className={`project-template-task ${className ?? ''}`}
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line import/namespace, @typescript-eslint/naming-convention
          __html: DOMPurify.sanitize(taskName),
        }}
      />
    </Tooltip>
  );
};

export const PhaseName = ({ phaseName }: PhaseNameProps) => {
  const content = (
    <div
      className="project-template-task"
      dangerouslySetInnerHTML={{
        // eslint-disable-next-line import/namespace, @typescript-eslint/naming-convention
        __html: DOMPurify.sanitize(phaseName),
      }}
    />
  );

  return (
    <Tooltip placement="topLeft" title={content} destroyTooltipOnHide>
      {content}
    </Tooltip>
  );
};
